import { TransferData, TransferDetail, TransferDetailContainer, TransferItem } from "../../styles";

interface TransferResume {
	item: string;
	data: string | number;
}

interface Resume {
	resume: TransferResume[];
}

const Resume = ({ resume }: Resume) => {
	return (
		<TransferDetail>
			{resume.map(({ item, data }: TransferResume) => (
				<TransferDetailContainer key={item}>
					<TransferItem>{item}</TransferItem>
					<TransferData>{data}</TransferData>
				</TransferDetailContainer>
			))}
		</TransferDetail>
	);
};

export default Resume;
